import {PreloaderStatus} from './PreloaderStatus';
import {PreloadInfoUpdate} from './PreloadInfoUpdate';

export class PreloaderInfo {
    private _fileName: string;
    private _resourceIdMappings: Object;
    private _status: PreloaderStatus;
    private _loadSucceed: boolean;
    private _audioLoaded: boolean;
    private _resourcesLoaded: boolean;
    private _xmlsLoaded: boolean;

    private static __updatePreloaderInfoAllowed = false;

    private constructor() {
        this._status = PreloaderStatus.Idle;
        this._loadSucceed = false;
        this._resourceIdMappings = {};
        this._fileName = '';
        this._audioLoaded = false;
        this._resourcesLoaded = false;
        this._xmlsLoaded = false;
    }

    public _update(info: PreloadInfoUpdate): void {
        if (!PreloaderInfo.__updatePreloaderInfoAllowed) {
            throw new Error('Direct updates to PreloaderInfo are not allowed!');
        }

        if (info.fileName !== undefined && info.fileName != null) {
            this._fileName = info.fileName;
        }

        if (info.resourceIdMappings !== undefined && info.resourceIdMappings != null) {
            this._resourceIdMappings = info.resourceIdMappings;
        }

        if (info.status !== undefined && info.status != null) {
            this._status = info.status;
        }

        if (info.loadSucceed !== undefined && info.loadSucceed != null) {
            this._loadSucceed = info.loadSucceed;
        }

        if (info.audioLoaded !== undefined && info.audioLoaded != null) {
            this._audioLoaded = info.audioLoaded;
        }

        if (info.resourcesLoaded !== undefined && info.resourcesLoaded != null) {
            this._resourcesLoaded = info.resourcesLoaded;
        }

        if (info.xmlsLoaded !== undefined && info.xmlsLoaded != null) {
            this._xmlsLoaded = info.xmlsLoaded;
        }

        PreloaderInfo.__updatePreloaderInfoAllowed = false;
    }

    private static _instance: PreloaderInfo = new PreloaderInfo();

    public static get instance(): PreloaderInfo {
        return PreloaderInfo._instance;
    }

    public get fileName(): string {
        return this._fileName;
    }

    public get status(): PreloaderStatus {
        return this._status;
    }

    public get loadSucceed(): boolean {
        return this._loadSucceed;
    }

    public get audioLoaded(): boolean {
        return this._audioLoaded;
    }

    public get resourcesLoaded(): boolean {
        return this._resourcesLoaded;
    }

    public get xmlsLoaded(): boolean {
        return this._xmlsLoaded;
    }

    public getResourcePathById(id: string): string {
        return this._resourceIdMappings.hasOwnProperty(id)
            ? this._resourceIdMappings[id]
            : null;
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/Preloader/Types/PreloaderInfo.ts
 **/